import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { ValueChangeEvent } from '@interfaces/form.interface';

@Component({
  selector: 'ark-range-slider',
  templateUrl: './range-slider.component.html',
  styleUrls: ['./range-slider.component.scss'],
})
export class RangeSliderComponent {
  @Input() id!: string;
  @Input() name!: string;
  @Input() min: number = 100;
  @Input() step: number = 1;

  private _max: number = 0;
  get max(): number {
    return this._max;
  }
  @Input() set max(v: number) {
    this._max = v;
    this.updateProgress();
  }

  updateProgress() {
    if (this.max <= 0 || this.value <= 0) {
      this.updateProgressBar(0);
    } else {
      const progress = (this.value / this.max) * 100 ?? 0;
      this.updateProgressBar(progress);
    }
  }
  updateProgressBar(value: number) {
    this.renderer.setStyle(
      this.inputRef.nativeElement,
      'background',
      `linear-gradient(to right, #000 ${value}%, #ccc ${value}%)`,
    );
  }

  private _value: number = 0;
  get value(): number {
    return this._value;
  }
  @Input() set value(v: number) {
    this._value = v;
  }

  @ViewChild('inputRef', { static: true }) inputRef!: ElementRef;

  active = false;
  mousemoveListener: any = null;
  mouseupListener: any = null;

  @Output() valueChanged = new EventEmitter<ValueChangeEvent>();

  constructor(private renderer: Renderer2) {}

  inputChange(event: any) {
    const value = event.target.value;
    const progress = (value / this.max) * 100;
    this.renderer.setStyle(
      this.inputRef.nativeElement,
      'background',
      `linear-gradient(to right, #000 ${progress}%, #ccc ${progress}%)`,
    );
  }
  valueChange(event: any) {
    this.valueChanged.emit({ value: event.target.value, status: 'VALID' });
  }
  touchStart(evt: MouseEvent | TouchEvent) {
    this.active = true;
    if (evt instanceof MouseEvent) {
      this.mousemoveListener = this.renderer.listen(
        'window',
        'mousemove',
        (event) => {
          this.valueChange(event);
        },
      );
      this.mouseupListener = this.renderer.listen(
        'window',
        'mouseup',
        (event) => {
          this.mousemoveListener();
          this.mouseupListener();
        },
      );
    } else {
      this.mousemoveListener = this.renderer.listen(
        'window',
        'touchmove',
        (event) => {
          this.valueChange(event);
        },
      );
      this.mouseupListener = this.renderer.listen(
        'window',
        'touchend',
        (event) => {
          this.mousemoveListener();
          this.mouseupListener();
        },
      );
    }
  }
}
